// Textos de «Anular» un código o cupón: confirmación y error.
import { ApiError } from '@/api/errors';
import type { DiscountCode, RetailPromotionsErrorCode } from '../api/promotionsContract';

const CODE_NOT_ACTIVE: RetailPromotionsErrorCode = 'CODE_NOT_ACTIVE';
const CODE_NOT_FOUND: RetailPromotionsErrorCode = 'CODE_NOT_FOUND';

export function voidConfirmCopy(code: DiscountCode): { title: string; description: string } {
    if (code.origin === 'SALE_COUPON') {
        return {
            title: `¿Anular el cupón ${code.codeText}?`,
            description:
                'El cliente que lo recibió ya no podrá usarlo. Las ventas donde ya se canjeó lo conservan. No se puede deshacer.',
        };
    }
    return {
        title: `¿Anular el código ${code.codeText}?`,
        description:
            'Deja de valer y ya no se acepta en ventas nuevas. Las ventas que ya lo aplicaron lo conservan. No se puede deshacer.',
    };
}

export function voidErrorDescription(error: unknown): string {
    if (error instanceof ApiError && error.code === CODE_NOT_ACTIVE)
        return 'El código ya no estaba vigente. Actualizamos la lista; revisa su estado.';
    if (error instanceof ApiError && error.code === CODE_NOT_FOUND)
        return 'No encontramos el código. Actualizamos la lista.';
    if (error instanceof Error && error.message) return error.message;
    return 'Intenta de nuevo en un momento.';
}
